import { ITopPeriodData } from '@/creditflowresearch/application/TopCompanies/interfaces';
import {
  ITopPeriodDataCorporate,
} from '@/creditflowresearch/application/TopCompanies/corporateTopCompanies/interfaces';

export const DEFAULT_PERIOD = 'past_12_months';

export const initialTopPeriods: ITopPeriodData | ITopPeriodDataCorporate = {
  collection: [
    {
      value: 'TTM',
      label: 'TTM',
      dateFrom: null,
      dateTo: null,
    },
  ],
  hasServerError: false,
};

export const initialTopCompanies = {
  topCompanies: {
    collection: [],
    totalCount: 0,
  },
  periods: initialTopPeriods,
  showExport: false,
  showVolume: false,
};
